export default {"id":"ae9e2d9e","attrs":{"viewBox":"0 0 25 24","width":"25","height":"24"}}